import { useTranslation } from 'libs/i18n';
import { CompanyRegistrationAddress } from 'modules/onboarding/legal/components';

import { useCompanyRegistrationAddress } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const CompanyRegistrationAddressStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
  } = useCompanyRegistrationAddress();

  const { step } = useOnboardingContext();

  const { t } = useTranslation();

  return (
    <CompanyRegistrationAddress
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      subTitle={t(
        'onboarding.legalClientLegalHead.companyRegistrationAddress.subtitle'
      )}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
